import React from 'react';
import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import GenesisSection from './components/GenesisSection';
import WhySupportSection from './components/WhySupportSection';
import InterventionsSection from './components/InterventionsSection';
import NewsSection from './components/NewsSection';
import DonorsSection from './components/DonorsSection';
import ImpactStoriesSection from './components/ImpactStoriesSection';
import BenefactorsSection from './components/BenefactorsSection';
import TestimonialsSection from './components/TestimonialsSection';
import PublicationsSection from './components/PublicationsSection';
import ResearchSection from './components/ResearchSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <HeroSection />
      <GenesisSection />
      <WhySupportSection />
      <InterventionsSection />
      <NewsSection />
      <DonorsSection />
      <ImpactStoriesSection />
      <BenefactorsSection />
      <TestimonialsSection />
      <PublicationsSection />
      <ResearchSection />
      <Footer />
    </div>
  );
}

export default App;